import $ from 'jquery';

$(document).ready(function() {
  $(".pd-accordion").on("click keypress", function(event) {
    if(event.which == 13 || event.type == "click"){
      $(this).toggleClass("active");
      $(this).next().slideToggle(200);
    }
  });
});


// WEBPACK FOOTER //
// ./components/cwm-package-details/scripts/package-details.js